import { render, staticRenderFns } from "./funcoesEditar.vue?vue&type=template&id=0b3323eb&scoped=true&"
import script from "./funcoesEditar.vue?vue&type=script&lang=js&"
export * from "./funcoesEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3323eb",
  null
  
)

export default component.exports